<template>
  <div class="dm-body">
    <template v-if="!user.loggedIn">
      <div v-if="showLogin">
        <Login />
          <!-- <p>Non ancora registrato? <span @click="showLogin = false" class="linkable">REGISTRATI</span></p> -->
          <p>Password dimenticata? <span @click="resetPwd" class="linkable">RESET Password</span></p>
      </div>
      <!-- <div v-else>
        <Signup />
          <p>Gia registrato? <span @click="showLogin = true" class="linkable">ACCEDI</span></p>
      </div> -->
    </template>
    <template v-else>
      <UserList />
    </template>
  </div>
</template>

<script>
  import Login from '../components/Login.vue'
  //import Signup from '../components/Signup.vue'
  //import Dashboard from './Dashboard.vue'
  import UserList from '../components/users/UserList.vue'
  import { mapGetters } from 'vuex'


  export default {
    data() {
      return {
          showLogin: true
      }
    },
    created() {
      if (!this.user.shopName) {
        this.user.loggedIn = false
        console.log('User NOT fully logged: ', this.user);
      }
    },
    computed: {
      ...mapGetters({
          // map `this.user` to `this.$store.getters.user`
          user: "user"
      })
    },
    components: {
      //Signup,
      Login,
      //Dashboard,
      UserList
    },
    methods: {
      resetPwd() {
        alert('Funzione da rilasciare a breve ...')
        return 
      }
    }
  };
</script>

<style>
.dm-body {
  text-align: center;
  padding: 20px 0;
}
.linkable {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
</style>